import {
    ACTION_POST_CREATE_NOVELTIES,
    ACTION_PUT_UPDATE_NOVELTIES,
    ACTION_DELETE_NOVELTIES,
    ACTION_GET_NOVELTIES,
    SET_NOVELTIES
} from "@/views/novelties/store/types/types.js"

import Swal from "sweetalert2";
import EventBus from '@/utils/event_bus.js';

import { NoveltiesService } from "../../../services";

const actions = {
    [ACTION_GET_NOVELTIES]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                NoveltiesService.getListNovelties(idGroup,idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload) {
                            const novelties = resp.data.payload;
                            commit(SET_NOVELTIES, novelties);
                            resolve(resp.data);
                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de novedades:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de novedades:", error);
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_NOVELTIES]: ({ state }, data) => {
        const idGroup = sessionStorage.getItem("idGroup");
        const idEmpresa = sessionStorage.getItem("idEmpresa");
        const idUsuario = sessionStorage.getItem("idUsuario");

        const formdata = new FormData();
        formdata.append("title", data.title);
        formdata.append("image", data.image);
        formdata.append("message", data.message);
        formdata.append("functionalityId", data.functionalityId);
        formdata.append("startDate", data.startDate);
        formdata.append("endDate", data.endDate);
        formdata.append("companyIds", data.companyIds);
        formdata.append("status", true);
        
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                NoveltiesService.postCreateNovelty(idGroup, idEmpresa, idUsuario, formdata)
                    .then(async (resp) => {
                        if (resp.data.payload.body.payload.newsUpdateId) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: 'La novedad fue creada exitosamente',
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp);
                            EventBus.$emit('formNovelties-submitted-successfully');
                        } else {
                            await Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: resp.data.payload.body.payload.Error,
                            });
                            reject("La petición fue incorrecta o falló");
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_PUT_UPDATE_NOVELTIES]: async ({ state }, data) => {
        const idGroup = sessionStorage.getItem("idGroup");
        const idEmpresa = sessionStorage.getItem("idEmpresa");
        const idUsuario = sessionStorage.getItem("idUsuario");
        
        const formdata = new FormData();
        formdata.append("title", data.title);
        formdata.append("image", data.image);
        formdata.append("message", data.message);
        formdata.append("functionalityId", data.functionalityId);
        formdata.append("startDate", data.startDate);
        formdata.append("endDate", data.endDate);
        formdata.append("companyIds", data.companyIds);
        formdata.append("status", data.status);
        
        return await new Promise((resolve, reject) => {
            state.loading = true;
            NoveltiesService.postUpdateNovelty(idGroup, idEmpresa, idUsuario, formdata, data.newsUpdateId)    
                .then(async (resp) => {
                    if (resp.data.payload.body.payload.newsUpdateId) {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: 'La novedad fue actualizada exitosamente',
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(resp);
                        EventBus.$emit('reload-update-novelties');
                    } else {
                        await Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: resp.data.payload.body.payload.Error,
                        });
                        reject("La petición fue incorrecta o falló");
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
        });
    },

    [ACTION_DELETE_NOVELTIES]: async ({ state }, newsUpdateId) => {
        const idGroup = sessionStorage.getItem("idGroup");
        const idEmpresa = sessionStorage.getItem("idEmpresa");
        const idUsuario = sessionStorage.getItem("idUsuario");
        
        return await new Promise((resolve, reject) => {
            state.loading = true;
            NoveltiesService.getDeleteNovelty(idGroup, idEmpresa, idUsuario, newsUpdateId) 
                .then(async (resp) => {
                    if (resp) {
                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: 'La novedad fue eliminada exitosamente',
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(resp);
                        EventBus.$emit('reload-delete-novelties');
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
        });
    },
}

export default actions;